export default function populateCheckingPaymentOption(option, data) {
  if (data && typeof data.token !== 'undefined') {
    option.token = data.token; // eslint-disable-line no-param-reassign
  }

  if (!option.details) {
    option.details = {};
  }

  if (data && data.updateOption) {
    option.details.accountNumber = data.updateOption.accountNumber; // eslint-disable-line no-param-reassign
    option.details.routingNumber = data.updateOption.routingNumber; // eslint-disable-line no-param-reassign
    option.details.firstName = data.updateOption.firstName; // eslint-disable-line no-param-reassign
    option.details.lastName = data.updateOption.lastName; // eslint-disable-line no-param-reassign
  }

  return option;
}
